var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0325 2.5C8.91618 2.49921 3.70229 6.93498 2.72302 12.9724C1.74375 19.0098 5.28826 24.8662 11.0913 26.7987C11.7163 26.9112 11.94 26.5275 11.94 26.1975C11.94 25.9013 11.93 25.1162 11.9263 24.0725C8.45752 24.8225 7.72502 22.4 7.72502 22.4C7.49666 21.6462 7.00574 20.9992 6.34127 20.5763C5.21627 19.8025 6.42752 19.82 6.42752 19.82C7.22837 19.9298 7.93321 20.4043 8.33627 21.105C8.67744 21.7253 9.25222 22.1837 9.9329 22.3783C10.6136 22.5729 11.3438 22.4875 11.9613 22.1413C12.0193 21.5088 12.3007 20.9176 12.755 20.4738C9.98752 20.16 7.07752 19.09 7.07752 14.3113C7.06216 13.0752 7.52114 11.8804 8.36002 10.9725C7.98046 9.89664 8.02516 8.71657 8.48502 7.6725C8.48502 7.6725 9.53127 7.33625 11.9125 8.94875C13.9548 8.38876 16.1102 8.38876 18.1525 8.94875C20.535 7.335 21.58 7.6725 21.58 7.6725C22.042 8.71607 22.0867 9.89697 21.705 10.9725C22.547 11.8803 23.0056 13.0783 22.985 14.3163C22.985 19.1075 20.0725 20.16 17.295 20.4688C17.8942 21.0813 18.2015 21.9217 18.1388 22.7763C18.1388 24.4438 18.1238 25.7888 18.1238 26.1975C18.1238 26.5313 18.3463 26.9188 18.9825 26.7963C24.7831 24.8604 28.3238 19.0037 27.3425 12.9679C26.3613 6.93207 21.1476 2.4986 15.0325 2.5Z",
    fill: "url(#paint0_linear_1244_1200)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1244_1200",
    x1: 2.56104,
    y1: 14.6597,
    x2: 27.5053,
    y2: 14.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(29, 29, 23)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(44, 44, 43)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.28c48d08454356a70be4f31eca602a2a.svg";
export { ForwardRef as ReactComponent };